import { formatDate } from '@angular/common';
export const APP_DATE_FORMAT = 'dd-MM-yyyy';
export const APP_DATE_LOCALE = 'en-US';
export function formatAppDate(value?: Date | string | number | null, pattern = APP_DATE_FORMAT): string {
  if (value === null || value === undefined || value === '')
    return '';
  // The API's unspecified DateTime values represent UTC, as in the MVC app.
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value) && !/(?:Z|[+-]\d{2}:\d{2})$/i.test(value))
    value += 'Z';
  return formatDate(value, pattern, APP_DATE_LOCALE);
}
